import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ITagsAPIResponse } from '../../shared/interfaces/tags.interface';
import { TDataQueryName } from '../configurations/router';
import { ContactDetailsModel } from '../../shared/models/contact-details.model';
import { ConversationDetailsModel, IConversationDetails } from '../../shared/models/conversation-details.model';
import { ILeasingPreferences, LeasingPreferencesModel } from '../../shared/models/leasing-preferences.model';
import { AppointmentDetailsModel, IAppointmentDetails } from '../../shared/models/appointment-details.model';
import { CampaignDetailsModel, ICampaignDetails } from '../../shared/models/campaign-details.model';

@Injectable({
  providedIn: 'root',
})
export class ConversationDataService {
  constructor(private readonly http: HttpClient) {}

  getTags(query: TDataQueryName, id: string): Observable<ITagsAPIResponse> {
    return this.http.get<ITagsAPIResponse>(`conversation-tags/${query}/${id}`);
  }

  getConversationDetails(query: TDataQueryName, id: string): Observable<IConversationDetails> {
    return this.http
      .get<IConversationDetails>(`conversation-details/${query}/${id}`)
      .pipe(map((response) => new ConversationDetailsModel(response)));
  }

  getContactDetails(query: TDataQueryName, id: string): Observable<ContactDetailsModel> {
    return this.http
      .get<ContactDetailsModel>(`contact-details/${query}/${id}`)
      .pipe(map((response) => new ContactDetailsModel(response)));
  }

  getLeasingPreferences(query: TDataQueryName, id: string): Observable<ILeasingPreferences> {
    return this.http
      .get<ILeasingPreferences>(`leasing-preferences/${query}/${id}`)
      .pipe(map((response) => new LeasingPreferencesModel(response)));
  }

  getAppointmentDetails(query: TDataQueryName, id: string): Observable<IAppointmentDetails> {
    return this.http
      .get<IAppointmentDetails>(`appointment-details/${query}/${id}`)
      .pipe(map((response) => new AppointmentDetailsModel(response)));
  }

  getCampaignDetails(query: TDataQueryName, id: string): Observable<ICampaignDetails> {
    return this.http
      .get<ICampaignDetails>(`campaign-details/${query}/${id}`)
      .pipe(map((response) => new CampaignDetailsModel(response)));
  }
}
